import React, { useEffect } from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import Image from '@nubank/nuds-web/components/Image/Image';
import styled from 'styled-components';

import { useDynamicYieldValues } from '../../../../../../../utils/dynamicYield';
import { ccRatesEvent } from '../../../../../tracking';

import CloseBtn from './Commons/CloseBtn';
import MainText from './Commons/MainText';
import LinkGat from './Commons/LinkGat';

const StyledBox = styled(Box)`
  gap: 8px;
  
  p {
    flex: 1;
  }
`;

function Default() {
  const { values: dynamicYieldValues } = useDynamicYieldValues();
  useEffect(() => {
    ccRatesEvent('default');
  },
  []);

  return (
    <Box>

      <CloseBtn />
      <MainText />

      {/* IMAGE BLOCK */}
      <StyledBox
        marginTop="6x"
        marginBottom="6x"
        display="flex"
        flexDirection="row"
        alignItems="center"
        paddingRight={{ xs: '24px', md: '48px' }}
      >
        <Image
          alt="Icono de una tarjeta"
          src="one-step/rtr/credit-card-magic.png"
          webp
          width="98px"
          height="99px"
        />

        <Typography variant="paragraph1" strong>
          Tarjeta de Crédito Nu
          <Typography variant="paragraph1">
            $0 anualidad, MSI y opciones de pago flexibles.
          </Typography>

        </Typography>
      </StyledBox>

      <StyledBox
        marginTop="2x"
        marginBottom="12x"
        display="flex"
        flexDirection="row"
        alignItems="center"
        paddingRight="60px"
      >
        <Image
          alt="Icono de una tarjeta"
          src="one-step/rtr/debit-card-magic.png"
          webp
          width="98px"
          height="99px"
        />

        <Typography variant="paragraph1" strong>
          Cuenta Nu de Débito:
          <Typography variant="paragraph1" tag="span">
            {' '}
            En la app puedes hacer crecer tus ahorros hasta un
            {' '}
          </Typography>
          {`${dynamicYieldValues.dynamicYieldTurbo}%`}
        </Typography>
      </StyledBox>

      <LinkGat />

    </Box>
  );
}

export default Default;
